import { Component, Input, OnInit } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd';
import { FinancialStatusYears } from 'src/app/Models/financialstatusyear';
import { FinancialYearData } from 'src/app/Models/financialyeardata';
import { ApiService } from 'src/app/Service/api.service';

@Component({
  selector: 'app-financialstatusyear',
  templateUrl: './financialstatusyear.component.html',
  styleUrls: ['./financialstatusyear.component.css']
})
export class FinancialstatusyearComponent implements OnInit {
  @Input() drawerClose: Function;
  @Input() data: FinancialStatusYears;
    isSpinning = false
  logtext:string = "";



  constructor(private api: ApiService, private message: NzNotificationService) {
  }

  ngOnInit() {
  
  }
  


  close(): void {
    this.drawerClose();

	this.logtext = 'CLOSED - FinancialStatusYears form';
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });

  }

  save(addNew: boolean): void {
    var isOk = true
   if (this.data.YEAR1_NAME == undefined || this.data.YEAR1_NAME == "") {
      this.message.error("Please Enter Year1 Name", "");
      isOk = false
    }
    if (this.data.YEAR2_NAME == undefined || this.data.YEAR2_NAME == "") {
      this.message.error("Please Enter Year2 Name", "");
      isOk = false
    }
    if(isOk){

    this.isSpinning = true;
  
      if (this.data.ID) {

	

        this.api.updateFinancialStatusYears(this.data)
          .subscribe(successCode => {
            if (successCode['code'] == "200") {
              this.message.success("FinancialStatusYears information updated Successfully...", "");

	this.logtext = 'Update & Close - FinancialStatusYears form - SUCCESS '+ JSON.stringify(this.data)+" KEYWORD [U - FinancialStatusYears ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });

              if (!addNew)
                this.drawerClose();
              this.isSpinning = false;
            }
            else {

	this.logtext = 'Update & Close - FinancialStatusYears form - ERROR - '+ JSON.stringify(this.data)+" KEYWORD [U - FinancialStatusYears ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });

              this.message.error("Failed to update financialStatusYears information...", "");
              this.isSpinning = false;
            }
          });
      }
      else {

        this.api.createFinancialStatusYears(this.data)
          .subscribe(successCode => {
            if (successCode['code'] == "200") {
              this.message.success("FinancialStatusYears information added successfully...", "");

              if (!addNew)
	{
                this.drawerClose();

	this.logtext = 'Save & Close - FinancialStatusYears form - SUCCESS - '+ JSON.stringify(this.data)+" KEYWORD [C - FinancialStatusYears ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });
	}

              else {
                this.data = new FinancialStatusYears();
	this.logtext = 'Save & New - FinancialStatusYears form - SUCCESS - '+ JSON.stringify(this.data)+" KEYWORD [C - FinancialStatusYears ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });

              }
              this.isSpinning = false;
            }
            else {
              this.message.error("Failed to add financialStatusYears information...", "");
	this.isSpinning = false;
	this.logtext = 'Save & Close - FinancialStatusYears form - ERROR - '+ JSON.stringify(this.data)+" KEYWORD [C - FinancialStatusYears ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });
              
            }
          });
      }
  }
}


}